import React from 'react';
import { Mail, Phone, Globe, MapPin } from 'lucide-react';
export function EmailSignatureAmel() {
  return <div className="max-w-3xl mx-auto p-8" data-id="element-79">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8" data-id="element-80">
        <table cellPadding="0" cellSpacing="0" border={0} style={{
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontSize: '15px',
        lineHeight: '1.4',
        borderCollapse: 'collapse'
      }} data-id="element-81">
          <tbody data-id="element-82">
            <tr data-id="element-83">
              <td style={{
              paddingRight: '32px',
              verticalAlign: 'middle',
              borderRight: '2px solid #1e293b',
              width: '140px'
            }} data-id="element-84">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wxtonoDTZefwd495z2JgnJ/LOGO_ET_SLOGAN_%281%29.jpg" alt="IPcom Logo" style={{
                width: '140px',
                height: 'auto',
                display: 'block'
              }} data-id="element-85" />
              </td>
              <td style={{
              paddingLeft: '32px',
              verticalAlign: 'middle'
            }} data-id="element-86">
                <table cellPadding="0" cellSpacing="0" border={0} style={{
                borderCollapse: 'collapse'
              }} data-id="element-87">
                  <tbody data-id="element-88">
                    <tr data-id="element-89">
                      <td style={{
                      paddingBottom: '10px'
                    }} data-id="element-90">
                        <div style={{
                        fontSize: '20px',
                        fontWeight: '600',
                        color: '#0f172a',
                        marginBottom: '2px',
                        letterSpacing: '-0.01em',
                        lineHeight: '1.2'
                      }} data-id="element-91">
                          Amel JAOUANI
                        </div>
                        <div style={{
                        fontSize: '15px',
                        color: '#475569',
                        fontWeight: '500',
                        lineHeight: '1.3'
                      }} data-id="element-92">
                          Responsable RH, IPcom
                        </div>
                      </td>
                    </tr>
                    <tr data-id="element-93">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-94">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-95">
                          Mobile :{' '}
                        </span>
                        <span style={{
                        color: '#1e293b',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-96">
                          06 99 86 56 57
                        </span>
                      </td>
                    </tr>
                    <tr data-id="element-97">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-98">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-99">
                          Tél :{' '}
                        </span>
                        <span style={{
                        color: '#1e293b',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-100">
                          +33 (0) 1 47 90 08 19
                        </span>
                      </td>
                    </tr>
                    <tr data-id="element-101">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-102">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-103">
                          Email :{' '}
                        </span>
                        <a href="mailto:a.jaouani@ipcom-fr.com" style={{
                        color: '#1e293b',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-104">
                          a.jaouani@ipcom-fr.com
                        </a>
                      </td>
                    </tr>
                    <tr data-id="element-105">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-106">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-107">
                          Web :{' '}
                        </span>
                        <a href="https://www.ipcom-fr.com" style={{
                        color: '#1e293b',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-108">
                          ipcom-fr.com
                        </a>
                      </td>
                    </tr>
                    <tr data-id="element-109">
                      <td style={{
                      paddingTop: '8px'
                    }} data-id="element-110">
                        <div style={{
                        fontSize: '13px',
                        color: '#64748b',
                        lineHeight: '1.4',
                        fontWeight: '400'
                      }} data-id="element-111">
                          17, Avenue des Louvresses, bât B2
                          <br data-id="element-112" />
                          92230 Gennevilliers, France
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}